var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-41"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.84,
    y: 97.88,
    width: 169.52,
    height: 189.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.17,
    y: 100.94,
    width: 166.19,
    height: 183.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.31 198.33 94.31 185.44 97.99 185.44 97.99 176.85 102.9 176.85 102.9 163.95 104.13 163.95 104.13 176.85 109.04 176.85 109.04 185.44 112.73 185.44 112.73 198.33 119.48 198.33 119.48 202.02 122.55 202.02 122.55 216.14 123.16 216.14 123.16 195.88 125 195.88 125 208.77 126.84 208.77 126.84 178.07 128.07 178.07 128.07 190.97 132.99 190.97 132.99 186.67 134.83 186.67 134.83 168.87 138.51 168.87 138.51 151.06 139.74 151.06 139.74 153.52 164.91 153.52 164.91 146.15 169.21 146.15 169.21 117.91 171.05 117.91 171.05 146.15 177.19 146.15 177.19 153.52 179.64 153.52 179.64 190.35 192.53 190.35 192.53 179.3 188.24 179.3 188.24 177.46 192.53 177.46 192.53 174.39 204.81 174.39 204.81 146.15 207.88 146.15 207.88 141.85 222.62 141.85 222.62 146.15 224.46 146.15 224.46 185.44 231.21 185.44 231.21 203.25 234.89 203.25 234.89 189.13 237.96 189.13 237.96 185.44 244.72 185.44 244.72 172.55 248.4 172.55 248.4 163.95 252.7 163.95 252.7 151.06 254.36 151.06 254.36 284.43 88.17 284.43 88.17 198.33 94.31 198.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 184.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 184.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.53,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.29,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.82,
    y: 213.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.58,
    y: 213.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 184.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.11,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 155.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 158.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 161.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 164.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 167.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 170.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 172.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 175.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 147.87,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 150.79,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 153.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 165.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.97,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 147.87,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 150.79,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 153.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 165.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 147.87,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 150.79,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 153.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 165.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 147.87,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 150.79,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 153.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 171.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.26,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 147.87,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 150.79,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 153.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 171.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 174.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 206.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 147.87,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 150.79,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 153.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 171.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 174.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 206.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.79,
    y: 209.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 174.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 177.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 180.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 183.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 186.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 189.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 192.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 201.23,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 204.15,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.85,
    y: 207.06,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 174.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 177.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 180.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 183.73,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 186.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 189.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.62,
    y: 192.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 174.99,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 177.9,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 180.82,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 183.73,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 186.65,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 189.57,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.38,
    y: 192.48,
    width: 2.5,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 184.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 207.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 210.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 213.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 216.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 219.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 222.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 225.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 228.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 231.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.44,
    y: 234.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 184.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 207.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 210.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 213.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 216.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 219.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 222.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 225.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 228.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 178.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 181.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 184.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 187.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 190.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 207.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 210.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 213.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 216.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 219.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 222.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 225.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 228.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 200.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 202.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 205.89,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 208.8,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 211.72,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 214.63,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 217.55,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 220.47,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 223.38,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 226.3,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 229.21,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 232.13,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1,
    y: 235.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 200.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 202.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 205.89,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 208.8,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 211.72,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 214.63,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 217.55,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 220.47,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 223.38,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 226.3,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 229.21,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 232.13,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 235.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 200.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 202.97,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 205.89,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 208.8,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 211.72,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 214.63,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 217.55,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 220.47,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 223.38,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 226.3,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 229.21,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 232.13,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 235.05,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.63,
    y: 237.96,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 200.92,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 203.84,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 206.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 209.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 212.59,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 215.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 218.42,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 221.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 224.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 227.17,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.98,
    y: 235.92,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 200.92,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 203.84,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 206.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 209.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 212.59,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 215.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 218.42,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 221.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 224.25,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 233,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 235.92,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 200.92,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 203.84,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 206.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 209.67,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 212.59,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 215.5,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 218.42,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 221.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 230.08,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 233,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 235.92,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 165.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 171.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 174.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 203.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 209.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 212.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 214.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 217.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.18,
    y: 220.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 165.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 171.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 174.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 217.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.95,
    y: 220.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 156.62,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 159.54,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 162.45,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 165.37,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 168.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 171.2,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 174.12,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 206.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 209.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 212.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 214.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.71,
    y: 220.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 207.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 210.85,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 216.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 219.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 222.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 225.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 228.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 231.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 234.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.16,
    y: 237.09,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 207.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 216.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 219.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 222.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 225.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 228.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 231.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 234.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: 237.09,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 193.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 196.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 199.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 202.1,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 205.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 207.93,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 213.76,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 216.68,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 219.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 222.51,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 225.43,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 228.34,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 231.26,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 234.18,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 237.09,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 203.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 206.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 209.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 212.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 217.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 220.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 223.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 226.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 232.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 235.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 238.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 203.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 206.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 209.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 212.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 220.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 223.69,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 229.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 232.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 235.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.66,
    y: 238.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 177.03,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 179.95,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 182.86,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 185.78,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 188.7,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 191.61,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 194.53,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 197.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 200.36,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 203.28,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 206.19,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 209.11,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 212.02,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 214.94,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 220.77,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 226.6,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 229.52,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 232.44,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 235.35,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 238.27,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 193.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 196.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 199.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 202.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 205.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 208.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 216.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 219.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 222.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 225.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 228.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 231.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.65,
    y: 234.48,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 193.66,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 196.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 199.49,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 202.41,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 205.32,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 208.24,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 216.99,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 219.9,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 222.82,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 225.74,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 228.65,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 231.57,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.41,
    y: 237.4,
    width: 1.74,
    height: 1.74,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.9,
    y: 98.31,
    width: 3.45,
    height: 189.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.98,
    y: 98.31,
    width: 2.92,
    height: 189.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.06,
    y: 98.31,
    width: 2.92,
    height: 189.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.93,357.88s4.46-9.73-.64-19.33-6.57-11.85-3.32-13.82,4.74,7.68,4.74,7.68a21.69,21.69,0,0,0,.48-13.58c-2.27-6.94-3.68-18.25-.59-19.46s.58,14.1,3.26,19.33a44.86,44.86,0,0,0,2.63-11.39c.37-5.58-.21-14.48,2.23-16.77s4-.7,1.6,11.6a128.48,128.48,0,0,0-2.38,22.31s5.3-16.14,8.85-16.61,3.55,4.76.51,9.29-8.91,12.66-9.87,16.84c0,0,5.81-12.15,11-8.43s-4.55,11.06-8.91,13.71-7.38,19.28-7.38,19.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.45,361.88s-4.34-9.8.87-19.32,6.72-11.76,3.49-13.78-4.83,7.61-4.83,7.61a21.68,21.68,0,0,1-.32-13.58c2.35-6.91,3.9-18.2.83-19.46s-.76,14.1-3.5,19.28a45.18,45.18,0,0,1-2.49-11.43c-.3-5.58.39-14.47-2-16.79s-4-.76-1.74,11.58a128.62,128.62,0,0,1,2.11,22.34s-5.1-16.22-8.65-16.75-3.6,4.71-.61,9.29,8.75,12.79,9.66,17c0,0-5.66-12.23-10.94-8.59s4.42,11.13,8.75,13.85,7.15,19.38,7.15,19.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.41 354.89 449.3 354.89 446.4 380.57 416.32 380.57 413.41 354.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.89,353.06c-.13-.87-3.11-21.4,2.85-28.49a6.47,6.47,0,0,1,5-2.44c12-.28,13.68,9.39,13.7,9.48l-1.42.22c-.06-.34-1.48-8.52-12.24-8.26a5,5,0,0,0-3.89,1.92c-5.55,6.6-2.56,27.15-2.53,27.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.16,352.13l-1.44-.05c0-.19.48-18.92-8.75-22.79-9-3.79-13.11,4-13.28,4.34L61.41,333c0-.09,4.82-9.33,15.12-5C86.67,332.22,86.18,351.32,86.16,352.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2,353.6c0-.3-.09-29.92-5.86-38.59-5.55-8.32-14.49-4.4-14.87-4.23l-.59-1.31c.1,0,10.42-4.6,16.65,4.74,6,9,6.11,38.15,6.11,39.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.42,322.84s-5.26,1.94-3.7,6.51,18.18,12.1,18.18,12.1,7-6.38.57-16.75S96.56,319.57,96.42,322.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08,313.45s3.73-.4,3.43-2.67-14.5-8.12-22.88,1.33c0,0,5.36,9.22,13.12,9.34S80.08,313.45,80.08,313.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25,328.63s2.57-2.08-.2-3.09-16.42-.73-16.56,12.77c0,0,15.88,2.64,17.85-2.5S76.25,328.63,76.25,328.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.24 380.57 74.6 380.57 71.94 353.6 101.9 353.6 99.24 380.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.63,
    y: 350.62,
    width: 32.59,
    height: 5.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.4,
    cy: 91.64,
    r: 14.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.4,
    cy: 91.64,
    r: 12.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "349.83 83.38 349.83 91.8 344.25 88.64",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,92.8a1.05,1.05,0,0,1-.49-.13l-5.58-3.16a1,1,0,1,1,1-1.74l4.09,2.31v-6.7a1,1,0,0,1,2,0V91.8a1,1,0,0,1-1,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.48,
    y: 124.51,
    width: 62.64,
    height: 82.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.79 133.31 379.79 169.66 394.27 168.85 395.93 133.31 379.79 133.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.51 140.34 413.79 140.34 413.6 172.16 402.06 172.34 391.51 140.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.82 135.66 375.68 135.66 373.63 164.04 366.3 165.86 369.82 135.66",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.86,
    y: 153.31,
    width: 62.44,
    height: 75.98,
    transform: "translate(636.16 382.59) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.15 210.47 333.96 178.22 298.46 172.36 301.15 210.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.17 202.82 334.79 178.09 310.09 184.16 308.29 203.08 333.17 202.82",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.85,
    cy: 168.02,
    r: 9.97,
    transform: "translate(-30.69 261.94) rotate(-45)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,211.64a4.84,4.84,0,1,1,4.84,4.84A4.84,4.84,0,0,1,329.94,211.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.63 220.14 319.66 211.64 331.4 201.97 333.63 220.14",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.39,
    y: 162.97,
    width: 2.75,
    height: 60.67,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.89,
    y: 162.97,
    width: 3.55,
    height: 57.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.13,
    y: 203.08,
    width: 18.15,
    height: 18.15,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-41"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-41",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Weights--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.15,299.55h-2.78c-8.79,0-15.92,9-15.92,20.13s7.13,20.12,15.92,20.12h2.78c8.8,0,15.93-9,15.93-20.12S282,299.55,273.15,299.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.08,319.68c0,11.11-7.13,20.12-15.93,20.12s-15.92-9-15.92-20.12,7.13-20.13,15.92-20.13S289.08,308.56,289.08,319.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8,304.77h-2.06c-6.52,0-11.8,6.67-11.8,14.91s5.28,14.91,11.8,14.91h2.06c6.51,0,11.8-6.68,11.8-14.91S282.31,304.77,275.8,304.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,319.68c0,8.23-5.29,14.91-11.8,14.91S264,327.91,264,319.68s5.28-14.91,11.8-14.91S287.6,311.44,287.6,319.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,315.11h-.63c-2,0-3.62,2-3.62,4.57s1.62,4.57,3.62,4.57h.63c2,0,3.62-2.05,3.62-4.57S280.44,315.11,278.44,315.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06,319.68c0,2.52-1.62,4.57-3.62,4.57s-3.61-2.05-3.61-4.57,1.62-4.57,3.61-4.57S282.06,317.15,282.06,319.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.81,262.58h-2.09c-6.6,0-11.94,6.76-11.94,15.1s5.34,15.09,11.94,15.09h2.09c6.59,0,11.94-6.76,11.94-15.09S281.4,262.58,274.81,262.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.81,
    cy: 277.68,
    rx: 11.94,
    ry: 15.09,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.79,266.49h-1.54c-4.89,0-8.85,5-8.85,11.19s4,11.18,8.85,11.18h1.54c4.89,0,8.85-5,8.85-11.18S281.68,266.49,276.79,266.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.79,
    cy: 277.68,
    rx: 8.85,
    ry: 11.18,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,274.25h-.47c-1.5,0-2.71,1.53-2.71,3.43s1.21,3.42,2.71,3.42h.47c1.5,0,2.72-1.53,2.72-3.42S280.27,274.25,278.77,274.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.77,
    cy: 277.68,
    rx: 2.71,
    ry: 3.43,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.43,345.53h-3.34c-10.55,0-19.1,10.81-19.1,24.15s8.55,24.15,19.1,24.15h3.34c10.56,0,19.11-10.81,19.11-24.15S283,345.53,272.43,345.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.43,
    cy: 369.68,
    rx: 19.11,
    ry: 24.15,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.61,351.79h-2.48c-7.81,0-14.15,8-14.15,17.89s6.34,17.89,14.15,17.89h2.48c7.81,0,14.15-8,14.15-17.89S283.42,351.79,275.61,351.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.76,369.68c0,9.88-6.34,17.89-14.15,17.89s-14.16-8-14.16-17.89,6.34-17.89,14.16-17.89S289.76,359.8,289.76,369.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.78,364.2H278c-2.4,0-4.34,2.45-4.34,5.48s1.94,5.49,4.34,5.49h.76c2.4,0,4.34-2.46,4.34-5.49S281.18,364.2,278.78,364.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.78,
    cy: 369.68,
    rx: 4.34,
    ry: 5.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 396.89 405.24 397.19 403.39 396.89 389.15 398.89 389.15 400.96 393.15 400.96 415.53 400.96 419.53 400.96 419.53 398.89 407.39 396.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 396.89 405.24 397.19 403.39 396.89 389.15 398.89 389.15 400.96 393.15 400.96 415.53 400.96 419.53 400.96 419.53 398.89 407.39 396.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.24 397.19 393.15 398.89 393.15 400.96 389.15 400.96 389.15 398.89 403.4 396.89 405.24 397.19",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 276.02,
    width: 4.99,
    height: 121.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 276.02,
    width: 4.99,
    height: 121.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.2,
    y: 276.02,
    width: 2.5,
    height: 121.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.39 396.89 285.23 397.19 283.39 396.89 269.14 398.89 269.14 400.96 273.15 400.96 295.52 400.96 299.52 400.96 299.52 398.89 287.39 396.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.39 396.89 285.23 397.19 283.39 396.89 269.14 398.89 269.14 400.96 273.15 400.96 295.52 400.96 299.52 400.96 299.52 398.89 287.39 396.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.23 397.19 273.14 398.89 273.14 400.96 269.14 400.96 269.14 398.89 283.39 396.89 285.23 397.19",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 276.02,
    width: 4.99,
    height: 121.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 276.02,
    width: 4.99,
    height: 121.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 276.02,
    width: 2.5,
    height: 121.1,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,369.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0H279.4c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66H402.62l.2,0A2.13,2.13,0,0,1,404.24,369.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,369.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0H279.4c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66H402.62l.2,0A2.13,2.13,0,0,1,404.24,369.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,345.53H408.1c-10.55,0-19.11,10.81-19.11,24.15s8.56,24.15,19.11,24.15h3.34c10.55,0,19.11-10.81,19.11-24.15S422,345.53,411.44,345.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.55,369.68c0,13.34-8.56,24.15-19.11,24.15S392.33,383,392.33,369.68s8.56-24.15,19.11-24.15S430.55,356.34,430.55,369.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.61,351.79h-2.47c-7.81,0-14.15,8-14.15,17.89s6.34,17.89,14.15,17.89h2.47c7.82,0,14.16-8,14.16-17.89S422.43,351.79,414.61,351.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.77,369.68c0,9.88-6.34,17.89-14.16,17.89s-14.15-8-14.15-17.89,6.34-17.89,14.15-17.89S428.77,359.8,428.77,369.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.79,364.2H417c-2.4,0-4.34,2.45-4.34,5.48s1.94,5.49,4.34,5.49h.76c2.39,0,4.34-2.46,4.34-5.49S420.18,364.2,417.79,364.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.13,369.68c0,3-1.95,5.49-4.34,5.49s-4.34-2.46-4.34-5.49,1.94-5.48,4.34-5.48S422.13,366.65,422.13,369.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,369.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0h-3.21c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66h3.21l.2,0A2.13,2.13,0,0,1,423.24,369.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,369.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64,2.1,2.1,0,0,1-1.42-2.23,2.7,2.7,0,0,1,.48-1.59,1.43,1.43,0,0,1,.94-.64A2.13,2.13,0,0,1,423.24,369.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,319.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0H279.4c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66H402.62l.2,0A2.13,2.13,0,0,1,404.24,319.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,319.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0H279.4c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66H402.62l.2,0A2.13,2.13,0,0,1,404.24,319.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,299.55h-2.78c-8.79,0-15.92,9-15.92,20.13s7.13,20.12,15.92,20.12h2.78c8.8,0,15.93-9,15.93-20.12S421,299.55,412.16,299.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.16,
    cy: 319.68,
    rx: 15.92,
    ry: 20.13,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.81,304.77h-2.06c-6.52,0-11.8,6.67-11.8,14.91s5.28,14.91,11.8,14.91h2.06c6.51,0,11.79-6.68,11.79-14.91S421.32,304.77,414.81,304.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.81,
    cy: 319.68,
    rx: 11.8,
    ry: 14.91,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.45,315.11h-.63c-2,0-3.62,2-3.62,4.57s1.62,4.57,3.62,4.57h.63c2,0,3.62-2.05,3.62-4.57S419.45,315.11,417.45,315.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.07,319.68c0,2.52-1.62,4.57-3.62,4.57s-3.61-2.05-3.61-4.57,1.61-4.57,3.61-4.57S421.07,317.15,421.07,319.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,319.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0h-3.21c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66h3.21l.2,0A2.13,2.13,0,0,1,423.24,319.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,319.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64,2.1,2.1,0,0,1-1.42-2.23,2.7,2.7,0,0,1,.48-1.59,1.43,1.43,0,0,1,.94-.64A2.13,2.13,0,0,1,423.24,319.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,277.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0H279.4c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66H402.62l.2,0A2.13,2.13,0,0,1,404.24,277.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,277.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0H279.4c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66H402.62l.2,0A2.13,2.13,0,0,1,404.24,277.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.81,262.58h-2.08c-6.6,0-11.94,6.76-11.94,15.1s5.34,15.09,11.94,15.09h2.08c6.6,0,11.95-6.76,11.95-15.09S420.41,262.58,413.81,262.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.76,277.68c0,8.33-5.35,15.09-11.95,15.09s-11.94-6.76-11.94-15.09,5.35-15.1,11.94-15.1S425.76,269.34,425.76,277.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.8,266.49h-1.55c-4.88,0-8.84,5-8.84,11.19s4,11.18,8.84,11.18h1.55c4.89,0,8.85-5,8.85-11.18S420.69,266.49,415.8,266.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.65,277.68c0,6.17-4,11.18-8.85,11.18s-8.85-5-8.85-11.18,4-11.19,8.85-11.19S424.65,271.5,424.65,277.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.78,274.25h-.47c-1.5,0-2.71,1.53-2.71,3.43s1.21,3.42,2.71,3.42h.47c1.5,0,2.71-1.53,2.71-3.42S419.28,274.25,417.78,274.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.49,277.68c0,1.89-1.21,3.42-2.71,3.42s-2.71-1.53-2.71-3.42,1.21-3.43,2.71-3.43S420.49,275.78,420.49,277.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,277.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64l-.2,0h-3.21c-.89,0-1.61-1-1.61-2.25a2.77,2.77,0,0,1,.47-1.59,1.42,1.42,0,0,1,1.14-.66h3.21l.2,0A2.13,2.13,0,0,1,423.24,277.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,277.68a2.68,2.68,0,0,1-.48,1.59,1.46,1.46,0,0,1-.94.64,2.1,2.1,0,0,1-1.42-2.23,2.7,2.7,0,0,1,.48-1.59,1.43,1.43,0,0,1,.94-.64A2.13,2.13,0,0,1,423.24,277.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,279.91v4.43h-.77l-2.62-4.91.44-1.75h.75C282.24,279.68,284.44,279.91,284.44,279.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,279.91v4.43h-.77l-2.62-4.91.44-1.75h.75C282.24,279.68,284.44,279.91,284.44,279.91Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,279.91v4.43h-.13l-2.62-4.91.44-1.75h.11C282.24,279.68,284.44,279.91,284.44,279.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,321.91v4.43h-.77l-2.62-4.91.44-1.75h.75C282.24,321.68,284.44,321.91,284.44,321.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,321.91v4.43h-.77l-2.62-4.91.44-1.75h.75C282.24,321.68,284.44,321.91,284.44,321.91Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,321.91v4.43h-.13l-2.62-4.91.44-1.75h.11C282.24,321.68,284.44,321.91,284.44,321.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,371.92v4.43h-.77l-2.62-4.91.44-1.75h.75C282.24,371.69,284.44,371.92,284.44,371.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,371.92v4.43h-.77l-2.62-4.91.44-1.75h.75C282.24,371.69,284.44,371.92,284.44,371.92Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.44,371.92v4.43h-.13l-2.62-4.91.44-1.75h.11C282.24,371.69,284.44,371.92,284.44,371.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.81,264.4S366,307.82,363.55,328c-2.59,21-7.9,74.21-7.9,74.21l-5.37.53s-7.7-51.53-4.35-72c2.2-13.39-10.39-74.92-10.39-74.92Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.7,266.68s-2.61,41.87-6.21,61.85c-3.74,20.79-12,73.67-12,73.67l-5.38.22s-4.84-51.87-.36-72.12c2.94-13.25,2.28-69.61,2.28-69.61Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.65,180.49a4.85,4.85,0,0,0,.37,3.11,6.31,6.31,0,0,0,2.45,1.81c-.76,1.47-3,2.17-3,2.17h-5.4s-2.44.54-3.36,0c-.77-.43-1.58-.84-2.3-1.33-.37-.25-1.09.38-1.44.07a8,8,0,0,0,2.91-3.67c.95-3-.07-13.48-.07-13.48l11.4,4.69s-.09.25-.22.68A34.73,34.73,0,0,0,342.65,180.49Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.58,175.58s2.45,5.08,8.07,4.91a34.73,34.73,0,0,1,1.32-5.93l-.7-.25Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.05,188.77s.61,2.92,1.48,7.62c.8,4.3,1.83,10.07,2.81,16.46.17,1.14.37,2.3.56,3.48,0,0,0,0,0,0,1.46,8.68,3.33,18.14,3.72,26.35L361,240.77c.27-8.13,1.35-20.48.15-34.15a121.14,121.14,0,0,0-3.46-21.15s-1.36-.07-3.69-.1c-1.61,0-3.66,0-6.05,0-5.28.06-12.15.33-19.18,1.1-2,.22-3.94.47-5.89.78C320.23,187.65,317.58,188.16,315.05,188.77Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.72,222.82h0c0,1.84-.07,3.61-.13,5.32-.08,2.33-.18,4.53-.28,6.57-.11,2.21-.21,4.23-.27,6.05l-37.42,1.92a123.08,123.08,0,0,0-1.53-13.41c-.24-1.59-.51-3.19-.78-4.77s-.6-3.44-.89-5.13c-.38-2.22-.75-4.41-1.08-6.53.21-.26.41-.52.61-.79a18.94,18.94,0,0,0,2.73-5.9,28.89,28.89,0,0,0,.9-4.79,47.37,47.37,0,0,0-.09-10.26c-.13-1.17-.28-2.18-.4-2.94-.07-.37-.12-.68-.17-.93,1.95-.31,3.93-.56,5.89-.78l.22.43a25.68,25.68,0,0,0,2.49,3.91,18.35,18.35,0,0,0,1.78,2h0a13,13,0,0,0,2.25,1.73,8.54,8.54,0,0,0,3.88,1.28,8.1,8.1,0,0,0,2.17-.15,8,8,0,0,0,2.85-1.13h0a7.36,7.36,0,0,0,3-4,12.41,12.41,0,0,0,.56-3.3,17.74,17.74,0,0,0,0-1.83c2.39,0,4.44,0,6.05,0,.51,2.12,1.36,5.68,2.12,8.86.46,1.9.89,3.66,1.18,4.88q0,.19.09.36a15.23,15.23,0,0,0,1.48,3.44c.67,1.22,1.49,2.51,2.28,3.71.09,1,.16,2,.22,3,.12,1.75.2,3.47.25,5.16C361.75,217.54,361.76,220.24,361.72,222.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.53,196.39c.8,4.3,1.83,10.07,2.81,16.46.17,1.14.37,2.3.56,3.48,3.91-6.37,2.66-15.1-.56-18.26A5.75,5.75,0,0,0,316.53,196.39Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.85,295.59c.68-26.28,5.82-55.82,5.86-59.62h39c1.69,9.49,4.5,44.26,3.51,60.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.48,413.67l1-4.75.18-8.56h7.16a1.75,1.75,0,0,1,2.86-1.17l1,7.91c1.81,1.62,6.07,3.33,11.73,4.57,1.26.28.86,3.32-2.22,3.32s-9.82-.23-12.05-.23c-3.63,0-5.73.18-8.62.22a1,1,0,0,1-.24,0A1.08,1.08,0,0,1,347.48,413.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,413.67l1.05-4.75,1.58-8.56h7.17a1.75,1.75,0,0,1,2.85-1.17l-.42,7.91c1.81,1.62,6.07,3.33,11.73,4.57,1.26.28.86,3.32-2.22,3.32s-9.82-.23-12.06-.23c-3.62,0-5.72.18-8.61.22a1,1,0,0,1-.24,0A1.08,1.08,0,0,1,314.88,413.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,250h-2.89c-3.25,0-5.9,3.34-5.9,7.46s2.65,7.46,5.9,7.46h2.89c3.26,0,5.9-3.34,5.9-7.46S298.83,250,295.57,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,250h-2.89c-3.25,0-5.9,3.34-5.9,7.46s2.65,7.46,5.9,7.46h2.89c3.26,0,5.9-3.34,5.9-7.46S298.83,250,295.57,250Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.47,257.5c0,4.12-2.64,7.46-5.9,7.46s-5.9-3.34-5.9-7.46,2.64-7.46,5.9-7.46S301.47,253.38,301.47,257.5Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.35,254.6H296.62c-1.27,0-2.29,1.3-2.29,2.9s1,2.9,2.29,2.9h10.73a3,3,0,0,0,0-5.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.45,187.83s-6.47-2.89-10.46,0-5.82,12.45-5.82,12.45-4.69,16-6,18.64.05,29.36.05,29.36l4.94.25s5.4-16.88,2.68-25.89c-.54-1.8,7.4-3.18,12.25-17.65,0,0,3.17-5.72,3.53-9.71A16.78,16.78,0,0,0,320.45,187.83Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2,248.28s-3.94,8.43-3.87,10.33,9,3.38,9,3.38,2.34-8.22,1.69-9.27-1.77-6.85-1.77-6.85Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,250h-2.89c-3.26,0-5.9,3.34-5.9,7.46s2.64,7.46,5.9,7.46H311c3.26,0,5.9-3.34,5.9-7.46S314.21,250,311,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,250h-2.89c-3.26,0-5.9,3.34-5.9,7.46s2.64,7.46,5.9,7.46H311c3.26,0,5.9-3.34,5.9-7.46S314.21,250,311,250Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.95,
    cy: 257.5,
    rx: 5.9,
    ry: 7.46,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.92,183.09l2.88-.05c3.26-.07,5.84-3.46,5.76-7.57s-2.79-7.41-6.05-7.35l-2.88.06c-3.26.06-5.84,3.45-5.76,7.57S394.66,183.16,397.92,183.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.92,183.09l2.88-.05c3.26-.07,5.84-3.46,5.76-7.57s-2.79-7.41-6.05-7.35l-2.88.06c-3.26.06-5.84,3.45-5.76,7.57S394.66,183.16,397.92,183.09Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.87,175.75c-.08-4.12,2.5-7.51,5.76-7.57s6,3.22,6,7.34-2.49,7.51-5.75,7.57S392,179.87,391.87,175.75Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,178.76l10.73-.21c1.26,0,2.27-1.34,2.23-2.94s-1.08-2.88-2.35-2.85l-10.73.21c-1.26,0-2.26,1.34-2.23,2.94S384.78,178.79,386.05,178.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.32,184.91s3.78-8.51,3.67-10.41-9.09-3.19-9.09-3.19-2.18,8.26-1.51,9.3,1.9,6.81,1.9,6.81Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.54,183.39l2.89,0c3.25-.07,5.83-3.46,5.75-7.57s-2.79-7.41-6.05-7.35l-2.88.06c-3.26.06-5.83,3.45-5.75,7.57S379.28,183.46,382.54,183.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.54,183.39l2.89,0c3.25-.07,5.83-3.46,5.75-7.57s-2.79-7.41-6.05-7.35l-2.88.06c-3.26.06-5.83,3.45-5.75,7.57S379.28,183.46,382.54,183.39Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,176.05c-.08-4.12,2.49-7.51,5.75-7.57s6,3.22,6.05,7.34-2.5,7.51-5.76,7.57S376.58,180.17,376.5,176.05Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.73,185.47s5.9-4.58,9.73-2.68,5,7.23,5,7.23a23.09,23.09,0,0,0,5.52,3.42c2.85,1.14,3.8,4.56,3.8,4.56l1.9,3.42c.2-4.23,6.84-18.44,6.84-18.44l5.14,1s-4.95,24.73-8.75,27.57-17.87-5.8-25.12-12.22l-2.26.81Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,295.94l2.51-20.46L351.35,265l-5.11,12.3s2.94,11.84,2.94,18.68Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62,154s3.39,9.91-1.81,13.3-4.34-14.23-4.34-14.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.84,174.1a8.63,8.63,0,0,0,9.71,3.82,9.59,9.59,0,0,0,5.68-4.18c.18-.28.34-.58.5-.89,2.76-5.67,4-15.75-1.88-19.85a9.32,9.32,0,0,0-13,2.29,9.2,9.2,0,0,0-1.6,4C332.18,166.05,331.23,170,333.84,174.1Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,163.42a.85.85,0,0,0,.43,1.12c.36.08.73-.3.86-.84s-.08-1-.43-1.12S343.08,162.88,343,163.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.08,164.78c-.16.53.07,1.05.42,1.12s.74-.3.86-.84-.07-1-.42-1.12S349.19,164.27,349.08,164.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.07,164.62a19.81,19.81,0,0,0,1.56,5.21,3.21,3.21,0,0,1-2.71-.1Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.26,161a.34.34,0,0,0,.34,0,2.61,2.61,0,0,1,2.33-.34.31.31,0,0,0,.42-.16.33.33,0,0,0-.16-.43h0a3.21,3.21,0,0,0-2.94.38.32.32,0,0,0-.1.45h0A.32.32,0,0,0,342.26,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.93,162.5a.24.24,0,0,0,.18-.05.33.33,0,0,0,0-.46h0a3.19,3.19,0,0,0-2.82-.94.32.32,0,0,0-.25.38h0a.33.33,0,0,0,.39.25h0a2.59,2.59,0,0,1,2.22.78A.34.34,0,0,0,351.93,162.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.29,168.72c0,.07-.07.15-.11.22a10.34,10.34,0,0,1-2.69,3.27c-1.24-2.42-4.39-1.91-4.39-1.91a4.27,4.27,0,0,0-2.12-2.09c-1.37-.45-5.34-1.09-5.34-1.09-.64-.62-.65-2.1-.54-3.23a12.09,12.09,0,0,1,.19-1.44l-.91.47s-.07.21-.18.57h0c-.1.37-.26.89-.43,1.55h0c-.26.94-.54,2.11-.78,3.36a29.74,29.74,0,0,0-.49,3.37h0c0,.53-.07,1.07-.07,1.56h0a10.93,10.93,0,0,0,.16,1.79h0v0a3.86,3.86,0,0,0,.81,1.84,10.68,10.68,0,0,0,3.59,2.46c.24.11.48.2.72.29,2.71.95,5.85.93,8.22-1.1C350.83,175.34,351.29,168.72,351.29,168.72Zm-11.12.26a5.2,5.2,0,0,1,3.63,1.71s3.85.47,3.34,3.59-3.71,3.25-4.69,2.13c-.83-.95.07-1.87.37-2.13l.08-.07-1.21-.74a.64.64,0,0,1-.1.13,2.42,2.42,0,0,1-4.13-.09l-.08-.12a3,3,0,0,1-.25-.62h0A3.12,3.12,0,0,1,340.17,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,172a21.72,21.72,0,0,0-1.42,2.79l-.53-.13c-2.42-.61-3.34-1.69-3.63-2.7a3.19,3.19,0,0,1,0-1.53,3.22,3.22,0,0,1,.28-.82,11.73,11.73,0,0,0,4.51,2.17C345.67,171.94,346,172,346,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.17,171.79l-.44.81c-2.28-.57-3.81-1.29-4.35-2.16a3.22,3.22,0,0,1,.28-.82A11.73,11.73,0,0,0,345.17,171.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,174.67c-2.42-.61-3.34-1.69-3.63-2.7a7.78,7.78,0,0,1,2.55,1.2A3,3,0,0,1,344,174.67Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.16,148.79c-7.12-.3-12.1,4.29-10.59,15.12.86,6.12,2.77,9,2.77,9-1.31-3-.6-8.64.36-8.74s.82,1,.82,1c2.18-1.21,4.6-4.92,3.73-7.48-2-6,5.34-6.5,7.13-4.26,0,0,3.72,2.37,5.24.53S347.75,145.52,341.16,148.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.15,164.13a6.47,6.47,0,0,0,2.92,4c1.94,1.17,3.52-.43,3.49-2.58,0-1.92-1.08-4.9-3.29-5.17A2.89,2.89,0,0,0,329.15,164.13Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.23,246.08a.28.28,0,0,1-.2-.1.25.25,0,0,1,.05-.35c1.28-1,1.8-4.12,2-5.71-.79,1.07-2.32,2.86-3.76,3.15a1.73,1.73,0,0,1-1.39-.26c-.9-.62-1-1.22-.85-1.62.33-1.23,2.75-2.17,6.31-2.44h.22c1,0,5,.1,6.06,1.68a1.69,1.69,0,0,1,.11,1.71,1.51,1.51,0,0,1-1.2,1.05c-1.39.19-3.29-1.65-4.43-2.92.64,1.66,1.78,4.39,2.71,5.39a.25.25,0,0,1,0,.35.25.25,0,0,1-.36,0c-1.06-1.14-2.31-4.24-2.93-5.87-.21,1.69-.77,4.84-2.17,5.9A.27.27,0,0,1,344.23,246.08Zm2.7-6.83c1.07,1.3,3.28,3.63,4.57,3.45a1.06,1.06,0,0,0,.81-.75,1.23,1.23,0,0,0-.06-1.24C351.47,239.57,348.51,239.28,346.93,239.25Zm-1,0c-3.4.34-5.13,1.24-5.35,2-.11.44.29.83.66,1.08a1.23,1.23,0,0,0,1,.18C343.64,242.3,345.25,240.21,345.9,239.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.78,230.19c-1.57.19-2.91-.67-5.33-1a8.23,8.23,0,0,0-2.36.08c-.24-1.59-.51-3.19-.78-4.77,2.05-.73,5.09-1.7,6.11-1.44,1.58.39,2.76,3.36,4.74,3.36s5.55-.79,6.24,1S331.34,230,329.78,230.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,228.15c-.08,2.33-.18,4.53-.28,6.57-1.13.11-2.38.2-3.58.21-3.56,0-3.21-1.18-6-2s-6.09.79-12.44,0,3.77-1.78,8.79-2.74,4.87-1.22,8.7-1.81A28.32,28.32,0,0,1,361.59,228.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.72,222.82h0c-3.52.13-8.55.55-10.43.19-2.91-.55-3.52-1.69-6.87-2s-11.36.47-7.36-2.49c3.76-2.79,10.65-1.17,12-1s-.72,3.59,1.59,3.47,8.05.52,9,0,2.37-1.48,0-3.47-.43-2.76,2-2.78C361.75,217.54,361.76,220.24,361.72,222.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.42,215.35c-4.42,0-4.22,3-6.6,2.19-1.1-.37-3.84.73-6.4,1.84-.38-2.22-.75-4.41-1.08-6.53.21-.26.41-.52.61-.79,2.14-.55,4.81-.91,6.48,0,3.16,1.71,3.55.52,5.73,1.12S337.84,215.35,333.42,215.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.41,209.6c-.68.4-1.39.83-2,1.24-2,1.3-2-.24-3.7-.1a11.66,11.66,0,0,1-3,0c-1.68-.14-.55-1.06,0-1.45s2.49-1.06,1.56-1.45a11.22,11.22,0,0,0-6.19-.93c-3.16.4-7.79.4-6.93-.55s2.44-.9,4.34-1.43a37.11,37.11,0,0,1,5.86-.92c1.69-.21,5.27-.82,7.58-1.1.67,1.22,1.49,2.51,2.28,3.71C361.28,207.62,361.35,208.61,361.41,209.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.54,201.64c.25,1.05-5.29,1.58-7.79,2.9s-2.38,2.33-4.35,1.82l-.72-.2a28.89,28.89,0,0,0,.9-4.79c2.52-.4,3.36.39,6.37.27C333.42,201.51,335.29,200.59,335.54,201.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,209.1a1,1,0,0,1-.26-.35l-.15-.22,0,0,0-.06a4,4,0,0,1-1-.16.63.63,0,0,1-.43-.75,8.15,8.15,0,0,1-1.15-.22c-1.21-.4-1.23-.29-3.8,0a2.5,2.5,0,0,0-2.11,2.21c0,.76,4.09.16,6.42.14a7.41,7.41,0,0,0,2.58-.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.34,199.11a22.78,22.78,0,0,1-3.88.94c-4,.59-7.51.8-6.19,0s.78-1.18,0-1.45-2.91.27-4.12,0a8.82,8.82,0,0,1-3.71-2.79,8.1,8.1,0,0,0,2.17-.15,8,8,0,0,0,2.85-1.13h0a26.44,26.44,0,0,0,8.21.12c1.37-.19,2.54-.33,3.48-.42C356.62,196.13,357.05,197.89,357.34,199.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.52,190.8a6.34,6.34,0,0,1-2.46.29c-3.55-.27-4.42.17-5.57,0-.13-1.17-.28-2.18-.4-2.94,1.54-.43,4-.94,5.94-1.28A25.68,25.68,0,0,0,331.52,190.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.29,187.42a4.57,4.57,0,0,1-3.82,3.07,12.41,12.41,0,0,0,.56-3.3C350,186.6,351.69,185.81,351.29,187.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,196.38c.15.8-.67.64-1.8.76s-3.09-.65-4.71-.76-1-1.73,0-2,3-1,5.85-1.58h0a13,13,0,0,0,2.25,1.73C334.41,195.21,333.81,195.57,334,196.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.48,413.67l1-4.75.18-8.56h7.16a1.75,1.75,0,0,1,2.86-1.17l1,7.91c1.81,1.62,6.07,3.33,11.73,4.57,1.26.28.86,3.32-2.22,3.32s-9.82-.23-12.05-.23c-3.63,0-5.73.18-8.62.22a1,1,0,0,1-.24,0A1.08,1.08,0,0,1,347.48,413.67Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,413.67l1.05-4.75,1.58-8.56h7.17a1.75,1.75,0,0,1,2.85-1.17l-.42,7.91c1.81,1.62,6.07,3.33,11.73,4.57,1.26.28.86,3.32-2.22,3.32s-9.82-.23-12.06-.23c-3.62,0-5.72.18-8.61.22a1,1,0,0,1-.24,0A1.08,1.08,0,0,1,314.88,413.67Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Treadmill--inject-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "90.8 318.34 101.42 253.11 97.39 247.55 94.61 247.55 82.17 319.21 90.95 406.38 93.73 406.38 102.3 406.38 105.08 406.38 90.8 318.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.61 247.55 98.64 253.11 88.03 318.34 102.3 406.38 90.95 406.38 82.17 319.21 94.61 247.55",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.02 318.34 160.63 253.11 156.6 247.55 153.83 247.55 141.38 319.21 150.17 406.38 152.94 406.38 161.51 406.38 164.29 406.38 150.02 318.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.83 247.55 157.85 253.11 147.24 318.34 161.51 406.38 150.17 406.38 141.38 319.21 153.83 247.55",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.28,409.59V392.72a5.18,5.18,0,0,1,6.14-5.08L264,404.51a5.17,5.17,0,0,1,4.21,5.08h0a5.18,5.18,0,0,1-5.18,5.17H174.46A5.18,5.18,0,0,1,169.28,409.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.15,409.58a5.16,5.16,0,0,1-5.17,5.17H174.45a5.17,5.17,0,0,1-5.17-5.17V392.72a5.12,5.12,0,0,1,2.44-4.38,5.18,5.18,0,0,1,3.71-.7L264,404.5A5.17,5.17,0,0,1,268.15,409.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.75,409.58a5.16,5.16,0,0,1-5.17,5.17H174.45a5.17,5.17,0,0,1-5.17-5.17V392.72a5.12,5.12,0,0,1,2.44-4.38l84.83,16.16A5.17,5.17,0,0,1,260.75,409.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.17,389.93v21.93H257v-3.21a2.93,2.93,0,0,0-2.37-2.87L171.7,389.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,412.7H170.74v-3.48H256.2a1.74,1.74,0,0,1,1.74,1.74h0A1.74,1.74,0,0,1,256.2,412.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,412.7H170.74v-3.48H256.2a1.74,1.74,0,0,1,1.74,1.74h0A1.74,1.74,0,0,1,256.2,412.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,409.59V392.72A5.17,5.17,0,0,1,82,387.64l88.53,16.87a5.17,5.17,0,0,1,4.2,5.08h0a5.18,5.18,0,0,1-5.17,5.17H81A5.17,5.17,0,0,1,75.84,409.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.71,409.58a5.17,5.17,0,0,1-5.17,5.17H81a5.16,5.16,0,0,1-5.17-5.17V392.72A5.18,5.18,0,0,1,82,387.64l88.53,16.86A5.18,5.18,0,0,1,174.71,409.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,409.58a5.17,5.17,0,0,1-5.17,5.17H81a5.16,5.16,0,0,1-5.17-5.17V392.72a5.13,5.13,0,0,1,2.43-4.38l84.84,16.16A5.18,5.18,0,0,1,167.31,409.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.25,261.58a2.39,2.39,0,0,1-1-.24l-17-8.5a2.31,2.31,0,0,1,1-4.38H177.72a2,2,0,0,1,.42,0l33.73,6.22a2.31,2.31,0,0,1-.84,4.55l-33.53-6.19H79l8.25,4.12a2.31,2.31,0,0,1-1,4.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.61,247.55l2.15-1.84a3.62,3.62,0,0,1,2.37-.88H148a13.87,13.87,0,0,1,6.43,1.59l.7.37a13.11,13.11,0,0,1,3.75,2.9,5.68,5.68,0,0,1,1.71,3.42H98.46S99.13,248.31,94.61,247.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,234.77h34.34a4.85,4.85,0,0,1,4.81,4.3l1.49,13a4.85,4.85,0,0,1-4.82,5.4H118.31a4.85,4.85,0,0,1-3.38-1.38l-13.28-13a4.85,4.85,0,0,1-.81-5.89h0A4.86,4.86,0,0,1,105,234.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,234.77h34.34a4.85,4.85,0,0,1,4.81,4.3l1.49,13a4.85,4.85,0,0,1-4.82,5.4H118.31a4.85,4.85,0,0,1-3.38-1.38l-13.28-13a4.85,4.85,0,0,1-.81-5.89h0A4.86,4.86,0,0,1,105,234.77Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.43 238.06 137.5 238.06 141.17 248.92 117.38 248.92 110.43 238.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.74 238.06 120.72 248.92 138.53 248.92 134.75 238.06 114.74 238.06",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195,279.66c-.11.65-.24,1.31-.37,2A186.34,186.34,0,0,1,188.58,304c-4.27,12.86-9.08,24.22-10.88,28.09-2.93,6.29-21.86,60.91-21.86,60.91l-4.49-.92s10.31-50.63,13.66-66.95c.19-.92.35-1.73.49-2.42.92-4.44,6.87-28.69,10-41.48.26-1,.49-2,.71-2.87.76-3.12,1.24-5.06,1.24-5.06s-14.81-10.69-16-29.21a37.43,37.43,0,0,1,0-4.62l27-1.41S198.63,259.47,195,279.66Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.58,304c-4.27,12.86-9.08,24.22-10.88,28.09-2.93,6.29-21.86,60.91-21.86,60.91l-4.49-.92s10.31-50.63,13.66-66.95c.19-.92.35-1.73.49-2.42.92-4.44,6.87-28.69,10-41.48.26-1,.49-2,.71-2.87,2.37-4.18,4.33-6.08,5.6-4.74C186.82,278.91,188.23,293.61,188.58,304Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.25,314.44l-11.84,12.35c6.2,1.93,11.72,3.19,16.87,5,12.07,4.23,60.79,18.8,60.79,18.8L246,346s-38.39-23.15-64.12-29.55Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.39,342.43c-.6,0-.36,7.46-.36,7.46s4.52,4.72,5.43,9.21,3.66,2.08,3.81-2.9.27-8.77.38-12.31S248.68,342.47,242.39,342.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.82,353.86a1.08,1.08,0,0,1-.2.66.71.71,0,0,1-.8.15.79.79,0,0,1-.49-.41,3,3,0,0,1-.14-1.68c-.34.6-.75,1.12-1.14,1.13s-.46-.17-.61-.51a1.17,1.17,0,0,1,0-1c.45-1,2.2-1.56,2.29-1.59h.08l.06,0h0l0,0h0a.18.18,0,0,1,.05.07A9.41,9.41,0,0,1,243.82,353.86Zm-1.28-.67a1.88,1.88,0,0,0,.13.88.43.43,0,0,0,.26.22c.29.09.36,0,.39,0,.3-.35-.07-1.72-.5-2.83A8.3,8.3,0,0,0,242.54,353.19Zm-1.81-.5a.87.87,0,0,0,.07.35c0,.1.14.28.24.27.34,0,1-1.05,1.4-2.14a3.18,3.18,0,0,0-1.64,1.23A.77.77,0,0,0,240.73,352.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9,238.51s-5.39,3.19-6.08,3.24-3.77,0-3.83-.23-.16-4.7-.16-4.7l4.89-2.31s3-.49,4.57.25Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.93,202.43a61.83,61.83,0,0,1,9.35,8.18,41.47,41.47,0,0,1,7.37,10.44,24.66,24.66,0,0,1,1.23,3.18,9.72,9.72,0,0,1,.31,1.12,5.91,5.91,0,0,1,.09,1.73,6.49,6.49,0,0,1-1,2.87,10.52,10.52,0,0,1-3,3,18.69,18.69,0,0,1-2.95,1.71,45.2,45.2,0,0,1-11.8,3.53,2,2,0,0,1-1.18-3.8l.09,0a72.25,72.25,0,0,0,9.78-5.18,17.55,17.55,0,0,0,1.92-1.49,3.52,3.52,0,0,0,1-1.23c0-.11-.05-.06-.08.12s.08.63-.14,0a18.17,18.17,0,0,0-1-2.19,39.48,39.48,0,0,0-6.43-8.26c-1.27-1.29-2.64-2.51-4-3.73s-2.87-2.39-4.2-3.4l-.1-.07a4,4,0,0,1,4.74-6.53Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,187.53c-.75,4,0,10.67,2.77,13.2,0,0-2.69,4-10.09,4.26-8.14.3-3.93-3.85-3.93-3.85,4.43-1.22,4.29-4.47,3.49-7.51Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,181.78c.06.53-.18,1-.53,1.05s-.68-.35-.74-.88.18-1,.54-1S162,181.25,162.05,181.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.47,180.91l-1.32-.2S160.91,181.62,161.47,180.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.66,182.36A14.68,14.68,0,0,1,160.1,186a2.31,2.31,0,0,0,2,.11Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,178.32a.27.27,0,0,0,.15,0,2.61,2.61,0,0,1,2.33,0,.32.32,0,0,0,.43-.12.31.31,0,0,0-.11-.43,3.27,3.27,0,0,0-2.92,0,.31.31,0,0,0-.15.42A.31.31,0,0,0,161,178.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.86,177.91c.29,6.6.55,9.39-2.42,13.19-4.48,5.72-12.69,4.87-15-1.45-2-5.69-2.16-15.53,4-19A8.84,8.84,0,0,1,179.86,177.91Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,392.11c.13-.59-7.22-1.9-7.22-1.9s-5.56,3.44-10.14,3.4-2.79,3.14,2.05,4.33l12,2.92C157.67,401.7,156.24,398.25,157.59,392.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,391.13a1.05,1.05,0,0,1-.6-.33.72.72,0,0,1,0-.82.8.8,0,0,1,.5-.39,3,3,0,0,1,1.67.22c-.51-.46-.93-1-.86-1.35s.25-.42.62-.5a1.16,1.16,0,0,1,.94.21c.88.64,1.08,2.47,1.09,2.56a.19.19,0,0,1,0,.08h0l0,.06h0l0,0h0l-.07,0A9.47,9.47,0,0,1,146.11,391.13ZM147,390a1.74,1.74,0,0,0-.89,0,.4.4,0,0,0-.27.2c-.14.26-.07.36,0,.39.27.37,1.69.29,2.87.1A8.51,8.51,0,0,0,147,390Zm.86-1.67a.69.69,0,0,0-.35,0c-.11,0-.3.08-.32.18-.06.33.84,1.14,1.81,1.81a3.24,3.24,0,0,0-.86-1.86A.79.79,0,0,0,147.89,388.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67,208.66c-1.75,3.4-3.57,6.71-5.5,10a116.4,116.4,0,0,1-6.28,9.85c-.32.42-.64.84-1,1.32l-.33.37c-.14.14-.2.23-.41.42l-.28.26a4.3,4.3,0,0,1-.36.29,5,5,0,0,1-1.15.64,4.68,4.68,0,0,1-3,.15,5.41,5.41,0,0,1-1.83-.94,8.19,8.19,0,0,1-1.63-1.8,18.9,18.9,0,0,1-1.62-3c-.41-1-.75-1.93-1.07-2.88a69.47,69.47,0,0,1-2.59-11.4,2,2,0,0,1,3.84-1.08l0,0c1.47,3.4,2.9,6.88,4.51,10.07.4.79.81,1.57,1.24,2.28a11.08,11.08,0,0,0,1.25,1.83c.18.2.39.36.31.25a1.56,1.56,0,0,0-.58-.29,2.57,2.57,0,0,0-1.59.07,2.41,2.41,0,0,0-.54.28l-.09.07h0s0-.07.06-.1l.13-.16c.19-.26.41-.6.64-1,.9-1.43,1.83-3,2.72-4.63l2.69-4.87,5.34-9.85a4,4,0,0,1,7.14,3.77Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,210.52s-1.06-6.18-.85-6.85,1.35-3.52,1.59-3.49,4.44,1.53,4.44,1.53l.4,5.4s-.61,3-1.86,4.17Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,177.86s2.82,13.24,14.3,13.24c1.58,0,4.72-3.62,6-10.2A11.4,11.4,0,0,0,175.12,168C163.42,164.92,160.11,176.69,163.14,177.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.55,181.87a6,6,0,0,1-.5,3.57c-.73,1.56-2,1.43-2.52.24s-.69-3.19.4-4.39S166.28,180.53,166.55,181.87Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,271c-.48,2.75-.93,6.09-1.33,9.69C178,296.15,177,316.6,177,316.6l-9.56,10.19a9.46,9.46,0,0,1-2.4-1.66c-7-6.48-8.28-24.22-7.65-41.46a337,337,0,0,1,4.11-39.59h0C162.05,244.41,183.52,256.62,181,271Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.94,203.11a91,91,0,0,0-4.16,15.16c-.07.31-.12.61-.17.92a66.4,66.4,0,0,0-.93,8.4,40.34,40.34,0,0,0,.79,10.47l-27,1.41s-1-3-2.15-7.59c-.54-2.22-1.11-4.81-1.6-7.6-.07-.45-.15-.91-.22-1.37-1-6.17-1.5-13.11-.43-19.07a32.57,32.57,0,0,1,6.49-3.25l1.27-.45c.91-.32,1.89-.61,2.93-.88L169,199a38.21,38.21,0,0,1,6.09-.85,29.09,29.09,0,0,1,7.1.48c.37.08.72.15,1.07.24a25.44,25.44,0,0,1,2.89.84c.34.11.67.23,1,.35A24.11,24.11,0,0,1,192.94,203.11Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.78,218.27c-.07.31-.12.61-.17.92a66.4,66.4,0,0,0-.93,8.4l-.82,2.61-27.54,1.68c-.54-2.22-1.11-4.81-1.6-7.6-.07-.45-.15-.91-.22-1.37,2.89-2,11-8,11.78-11.63s-4.21-9.16-5.72-10.69l1.27-.45c.91-.32,1.89-.61,2.93-.88L169,199c1.32,1.94,4.71,6.3,7.95,6.05,3.43-.25,4.85-4.84,5.24-6.42.37.08.72.15,1.07.24a25.44,25.44,0,0,1,2.89.84c.34.11.67.23,1,.35-.7,2.44-2.35,8.48-2.26,11.27C185,213.63,187.24,216.56,188.78,218.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,238.06l-27,1.41s-1-3-2.15-7.59c-.54-2.22-1.11-4.81-1.6-7.6,3.43-1.89,12.81-7.53,12.91-12.51.09-4.55-3.81-9.44-5.8-11.63.91-.32,1.89-.61,2.93-.88,2.41,2.76,6.73,7,10.06,6.48s4.87-4.53,5.46-6.92a25.44,25.44,0,0,1,2.89.84c-1.15,3.44-3.22,10.27-2.52,12.6.57,1.9,3.07,4.87,5,6.93a66.4,66.4,0,0,0-.93,8.4A40.34,40.34,0,0,0,188.47,238.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,279.66c-.11.65-.24,1.31-.37,2l-13.44-1.17-1.53.2-4.18.57-18.16,2.44a337,337,0,0,1,4.11-39.59h0a37.43,37.43,0,0,1,0-4.62l27-1.41S198.63,259.47,195,279.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7,280.66l2.13-6.18s7.69-.37,11.11-4.15c0,0-2.18,6.85-7.43,10.5Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,169.42s.56-4.22,6.69-6.33,7.22,12.26,10.88,15.74,7.41-1,7.41-1-.18,6.92-7.5,6.92-13.82-10.95-13.82-10.95l-3-.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.39,342.43c-.6,0-.36,7.46-.36,7.46s4.52,4.72,5.43,9.21,3.66,2.08,3.81-2.9.27-8.77.38-12.31S248.68,342.47,242.39,342.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,392.11c.13-.59-7.22-1.9-7.22-1.9s-5.56,3.44-10.14,3.4-2.79,3.14,2.05,4.33l12,2.92C157.67,401.7,156.24,398.25,157.59,392.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner3);
export default __webpack_public_path__ + "static/media/banner3.774417f26f13c655d58174d7a95e194a.svg";
export { ForwardRef as ReactComponent };